// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Chartist from 'vue-chartist';
import VeeValidate from 'vee-validate';
// import Legend from 'chartist-plugin-legend';
// import * as Tooltips from 'chartist-plugin-tooltips';
import 'vuetify/dist/vuetify.min.css'; // Ensure you are using css-loader
import Vuetify from 'vuetify';
import VueClipboard from 'vue-clipboard2';
import App from './App';
import MPayLayout from './mc/components/MPayLayoutMc';
import MPayMessagesMixin from './components/MPayMessagesMixin';
import router from './mc/router';
import store from './store';
import validation from './utils/validation';
import MPayHelpersMixin from './components/MPayHelpersMixin';

require('../node_modules/chartist-plugin-tooltips/dist/chartist-plugin-tooltip.css');
require('../node_modules/material-design-icons-iconfont/dist/material-design-icons.css');

Vue.use(Vuetify, {
  theme: {
    primary: '#03312E',
    secondary: '#055853',
    accent: '#7938F5',
    error: '#f44336',
    warning: '#ffeb3b',
    info: '#2196f3',
    success: '#4caf50',
  },
  options: {
    customProperties: true,
  },
});
Vue.config.productionTip = false;

Vue.use(VeeValidate);
Vue.use(VueClipboard);
Chartist.plugins = Chartist.plugins || {};

Vue.use(Chartist, {
  messageNoData: 'No data',
  classNoData: 'chartist__no-data',
});

Vue.component('MPayLayout', MPayLayout);
Vue.mixin(MPayMessagesMixin);
Vue.mixin(MPayHelpersMixin);

/* eslint-disable no-new */
const vue = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
});

store.dispatch('init', router);

validation.extendValidator(vue);



// WEBPACK FOOTER //
// ./src/mc.js